import axios from 'axios';

const config = {
  baseURL: `${process.env.CLASS_SERVICE_URL}`,
  timeout: 120000,
  withCredentials: true,
};

const GCLASS_SERVICE_API = axios.create(config);

export default GCLASS_SERVICE_API;
